import { defineStore } from "pinia";

import { getProfile } from "../api/me";
import { PermissionController, User } from "../api/models/user";
import { flatRoutes } from "../router";

import { useAuthStore } from "./auth";

export const useUserStore = defineStore({
  id: "user",
  state: () => {
    return {
      isLoading: false,
      hasNetworkError: false,
      activeUser: null as User | null,
      initialLoggedInRoute: "/produtos/home",
    };
  },
  actions: {
    doesActiveUserHavePermissionController(permissionController: PermissionController) {
      return this.activeUser?.permissions
        ?.map(({ controller }) => controller)
        .includes(permissionController);
    },

    loadInitialLoggedInRoute() {
      // Seleciona a rota de maior prioridade (menor número) que o usuário tem permissão.
      let priority = 1000;

      flatRoutes.forEach(({ path, meta }) => {
        if (
          (meta?.priority || meta?.priority === 0) &&
          (!meta?.permissionController ||
            this.doesActiveUserHavePermissionController(meta.permissionController)) &&
          meta.priority < priority
        ) {
          priority = meta.priority;
          this.initialLoggedInRoute = path.replace("/:id?", "");
        }
      });
    },

    async loadUserData() {
      if (!this.activeUser && useAuthStore().accessToken) {
        try {
          this.isLoading = true;

          this.activeUser = await getProfile();
          this.loadInitialLoggedInRoute();
        } catch (_) {
          this.hasNetworkError = true;
        } finally {
          this.isLoading = false;
        }
      }
    },
    async reloadUserData() {
      if (useAuthStore().accessToken) {
        try {
          this.activeUser = await getProfile();
        } catch (_) {
          this.hasNetworkError = true;
        }
      }
    },
  },
});
